import useContentfulVariation from './useContentfulVariation'

export default function useContentfulSearchFormHeadlines(
  name: string,
  shouldFireImpression = true
) {
  const searchForm = useContentfulVariation<any>(name, shouldFireImpression)
  return searchForm ?? null
}
